import { render, staticRenderFns } from "./UserActionsTabs.vue?vue&type=template&id=5c6b3f1f&"
import script from "./UserActionsTabs.vue?vue&type=script&lang=js&"
export * from "./UserActionsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports